'use client'

import React from 'react'

import { TravellerDocDetail } from '@/src/types/traveller'

import { useTravellerDocTabs } from '@/src/hooks/travellers/useTravellerDocTabs'

import { TravellerDetailView } from './travellerDetail'

interface TravellerDetailWrapperProps {
    t: (key: string) => string
    documents: TravellerDocDetail[]
}

const TravellerDetailWrapper: React.FC<TravellerDetailWrapperProps> = ({ t, documents }) => {
    const { activeDocType, activeDoc, activeExpiryDateValue, onTabChange } = useTravellerDocTabs(documents)

    return (
        <TravellerDetailView
            t={t}
            documents={documents}
            activeDocType={activeDocType}
            activeDoc={activeDoc}
            activeExpiryDateValue={activeExpiryDateValue}
            onTabChange={onTabChange}
        />
    )
}

export { TravellerDetailWrapper }
export type { TravellerDetailWrapperProps }
export default TravellerDetailWrapper

